export default __webpack_public_path__ + "media/images/app-icon-9a9380efabaf63cd5189ef26855d1a33.svg";